import { render, staticRenderFns } from "./StepResults.vue?vue&type=template&id=4b3af8c4"
import script from "./StepResults.vue?vue&type=script&lang=js"
export * from "./StepResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports